export const SET_EMAIL_RESEND_STATUS = 'SET_EMAIL_RESEND_STATUS';
export const SET_IS_EMAIL_RESEND_FETCHING = 'SET_IS_EMAIL_RESENT_FETCHING';
export const SET_EMAIL_RESEND_COUNTDOWN_START = 'SET_EMAIL_RESEND_COUNTDOWN_START';
export const RESET_EMAIL_RESEND_COUNTDOWN_START = 'RESET_EMAIL_RESEND_COUNTDOWN_START';
export const SET_EMAIL_RESEND_SENT_TO_EMAIL = 'SET_EMAIL_RESEND_SENT_TO_EMAIL';
export const RESET_EMAIL_RESEND_SENT_TO_EMAIL = 'RESET_EMAIL_RESEND_SENT_TO_EMAIL';

